import { UrlTree, DefaultUrlSerializer } from '@angular/router';
import { Injectable } from '@angular/core';

// This adds a trailing slash to all urls if the url does not contain a "." character
@Injectable()
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {

  public override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    return TrailingSlashUrlSerializer.normalize(url);
  }

  public static normalize(url: string): string {
    const splitCharacter = url.indexOf('?') !== -1 ? '?' : '#';

    const urlParts = url.split(splitCharacter);
    if (!urlParts[0].endsWith('/') && !urlParts[0].includes('.')) {
      urlParts[0] += '/';
    }
    return urlParts.join(splitCharacter);
  }

}
